import {useState, useEffect, useRef} from "react";
import "./AnswerButton.scss";

const MultiChoiceSelectionButton = ({ answer, index, onClick, buttonType, fontSize, setContainerRef }) => {
    return (
        <button className="AnswerButton" onClick={() => onClick(index)}>
            <div className="AnswerButtonReflection" />
            <ButtonContent
                buttonType={buttonType}
                content={answer}
                index={index}
                fontSize={fontSize}
                setContainerRef={setContainerRef}
            />
        </button>
    );
};

const ButtonContent = ({ buttonType, content, index, fontSize, setContainerRef }) => {
    const letters = ["A", "B", "C"];

    const displayContent =
        buttonType === "cash"
            ? new Intl.NumberFormat(navigator.language, {
                style: "currency",
                currency: "GBP",
                maximumFractionDigits: 0,
                minimumFractionDigits:0
            }).format(content)
            : content;

    return (
        <div ref={setContainerRef} className="LabelContainer">
            {buttonType === "answer" && (
                <p className="AnswerLetter">{letters[index]}</p>
            )}
            <p
                className="AnswerText"
                style={{ fontSize: `${fontSize}em`, whiteSpace: "nowrap" }}
            >
                {displayContent}
            </p>
        </div>
    );
};




export default MultiChoiceSelectionButton;
